<template>
    <div class="user">
        <div class="photo">
            <img src="@/assets/img/james.jpg" alt="avatar"/>
        </div>
        <div class="info">
            <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
                <span>
                    {{ $store.state.user.email }}
                    <b class="caret"></b>
                </span>
            </a>
            <div class="clearfix"></div>
            <div>
                <collapse-transition>
                    <ul class="nav" v-show="!isClosed">
                        <slot>
                            <!-- <li>
                                <a href="#vue">
                                <span class="sidebar-mini-icon">MP</span>
                                <span class="sidebar-normal">My Profile</span>
                                </a>
                            </li>
                            <li>
                                <a href="#vue">
                                <span class="sidebar-mini-icon">EP</span>
                                <span class="sidebar-normal">Edit Profile</span>
                                </a>
                            </li> -->
                            <li>
                                <a @click.prevent="logout()" href="/login">
                                    <span class="sidebar-mini-icon">L</span>
                                    <span class="sidebar-normal">Logout</span>
                                </a>
                            </li>
                        </slot>
                    </ul>
                </collapse-transition>
            </div>
        </div>
    </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions'

export default {
    components: {
        CollapseTransition
    },
    data () {
        return {
            isClosed: true
        }
    },
    methods: {
        toggleMenu () {
            this.isClosed = !this.isClosed
        },
        logout () {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'login' })
        }
    }
}
</script>

<style lang="scss">
    .collapsed {
        transition: opacity 1s
    }

    .user {
        .info {
            .caret {
                right: -5px !important
            }
        }
    }
</style>
